module.exports = __webpack_public_path__ + "static/img/ureter-1.da2b49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-1.jpg
// module id = AJu9
// module chunks = 52